export default __webpack_public_path__ + "static/media/error.836c0684.svg";